import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa11e600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "姓名", -1))
const _hoisted_5 = { class: "id" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "身份证号", -1))
const _hoisted_8 = { class: "idphoto1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "身份证人像面", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao1" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "set" }, " 请上传图片,仅支持jpg、png、dgft格式,单张大小不得超过5M ", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "idphoto1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "身份证国徽面", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao1" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "set" }, " 请上传图片,仅支持jpg、png、dgft格式,单张大小不得超过5M ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: _ctx.selfverifyForm,
      rules: _ctx.rules,
      class: "demo-ruleForm",
      "status-icon": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_el_form_item, { prop: "name" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.selfverifyForm.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selfverifyForm.name) = $event)),
                placeholder: "   请输入姓名"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_el_form_item, { prop: "card_id" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.selfverifyForm.card_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selfverifyForm.card_id) = $event)),
                placeholder: "   请输入身份证号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createVNode(_component_el_form_item, { prop: "card_pic" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: _normalizeClass(["avatar-uploader", { nonejiahao: _ctx.selfverifyForm.card_pic.length > 0 }]),
                "file-list": _ctx.selfverifyForm.card_pic,
                "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selfverifyForm.card_pic) = $event)),
                "on-preview": _ctx.handlePictureCardPreview,
                action: "",
                "list-type": "picture-card",
                accept: ".jpg,.png,.dgft",
                limit: 3,
                "before-upload": _ctx.beforeUpload
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["file-list", "on-preview", "before-upload", "class"])
            ]),
            _: 1
          })
        ]),
        _hoisted_12,
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              "w-full": "",
              src: _ctx.dialogImageUrl,
              alt: "Preview Image",
              class: "bigimg"
            }, null, 8, _hoisted_13)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.dialogVisibles,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisibles) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              "w-full": "",
              src: _ctx.dialogImageUrls,
              alt: "Preview Image",
              class: "bigimg"
            }, null, 8, _hoisted_14)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _createVNode(_component_el_form_item, { prop: "card_pic_other" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: _normalizeClass(["avatar-uploader", { nonejiahao: _ctx.selfverifyForm.card_pic_other.length > 0 }]),
                "file-list": _ctx.selfverifyForm.card_pic_other,
                "onUpdate:fileList": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selfverifyForm.card_pic_other) = $event)),
                action: "",
                "on-preview": _ctx.handlePictureCardPreviews,
                "list-type": "picture-card",
                accept: ".jpg,.png,.dgft",
                limit: 3,
                "before-upload": _ctx.beforeUploads
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["file-list", "on-preview", "before-upload", "class"])
            ]),
            _: 1
          })
        ]),
        _hoisted_19,
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "routine submit",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}